jQuery(window).on("load", function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 6000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  
  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });
    
  
});




jQuery(document).ready(function($){
  
  $(".tweet").tweet({ // twitter plugin
    username: "shopify",
    join_text: "auto",
    avatar_size: 32,
    count: 2,
    auto_join_text_default: "", 
    auto_join_text_ed: "",
    auto_join_text_ing: "",
    auto_join_text_reply: "",
    auto_join_text_url: "",
    loading_text: "Loading Tweets..."
  });
  function runOwlTestimonials(slideClass){
  
      if($(window).width() > 767){
           var owlsider = $(slideClass).owlCarousel({
            items: 3,
            loop: true,
             rtl:false,
            margin: 0,
            slideTransition: 'linear',
            autoplayTimeout: 0,
            autoplay: false,
            autoplayTimeout: 3500,
            dots: false,
            nav: true,
            
            responsiveClass: true,
            responsive:{
              0:{
                items:1
              },
              850:{
                items:1
              },
              992:{
                items:3
              }
            }
          });
      }else{
         var owlsider = $(slideClass).owlCarousel({
            items: 1,
            loop: true,
            rtl:false,
            margin: 0,
            autoplay: false,
            autoplayTimeout: 3500,
            dots: false,
            nav: true,
           responsive:false
          });
      } 
    return owlsider;
  }
    var fancyMain = $("#testimonail-outer").html();

    var testimonial_class = ".testimonials-list";
    var firstinst = runOwlTestimonials(testimonial_class);

  	 var fancpop = $(".popup-reviews").fancybox({
      		'titlePosition'     : 'inside',
            'transitionIn'      : 'none',
            'transitionOut'     : 'none',
      		 'hideOnOverlayClick': true,
       		'modal': true,
       		'autoScale': true,
             'padding': 0,
             'height':550,
       			'width':1464,
       		'autoDimensions':true,
             'onStart': function(){
             
            
              

               //var owlslider = runOwlTestimonials(testimonial_class);
               

               $("body").css("overflow", "hidden");
               
             },
       		'onClosed': function () {
              var sliderhtml = "<div class=''"
              $('#testimonail-outer').html(fancyMain);
              $("body").css("overflow", "visible");
              runOwlTestimonials(testimonial_class);
            }
        });


  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });
 $(".reviews-line a").click(function() {
    $('html,body').animate({
        scrollTop: $("#popup-reviews").offset().top - 50},
        'slow');
});
  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  $('#product .add-to-cart').click(function(e){
    $('#add-item-to-cart').click();
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  /*$('a[href^="#"]').bind('click.smoothscroll',function (e) {
    e.preventDefault();
    
    var target = this.hash,
        $target = $(target);
    
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });*/
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });
  
  var winwidth = $(window).width();
  if(winwidth < 769){
    $('a[target="_blank"]').removeAttr('target');
  }
  
}); // end document ready

$(document).ready(function() {

  //var sync1 = $("#sync1_");
  //var sync2 = $("#sync2_");
  var wrap = $('.product_image');
  var sync1 = wrap.find(".sync1");
  var sync2 = wrap.find(".sync2");
  var slidesPerPage = 4; //globaly define number of elements per page
  var syncedSecondary = true;

  
  console.log("adding fancybox code");
  
  var elg = $('.lightgallery').lightGallery({
    
    getCaptionFromTitleOrAlt :true,
    download  :false,
    counter :false,
    enableDrag :false,
    closable: true,
    hideBarsDelay :500000,
    preload : 2,
    cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)'
  });
  
  elg.on('onSlideItemLoad.lg', function(event, prevIndex, index){
    console.log(event);
    $(".lg-cclose").on("click", function(){
      
      elg.data('lightGallery').destroy();
    });
     $(".lg-cclose").on("touchend", function(){
      
      elg.data('lightGallery').destroy();
    });
  });
  elg.on('onAfterSlide.lg',function(event, prevIndex, index){
    $(".lg-cclose").on("click", function(){
      console.log(event);
      elg.data('lightGallery').destroy();
    });
  });
  /*sync1.owlCarousel({
    items: 1,
    slideSpeed: 2000,
    nav: true,
    autoplay: false, 
    dots: true,
    loop: true,
    responsiveRefreshRate: 200,
    navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
  }).on('changed.owl.carousel', syncPosition);

  /*sync2
  .on('initialized.owl.carousel', function() {
    sync2.find(".owl-item").eq(0).addClass("current");
  })
  .owlCarousel({
    items: slidesPerPage,
    dots: true,
    nav: true,
    smartSpeed: 200,
    slideSpeed: 500,
    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
    responsiveRefreshRate: 100
  }).on('changed.owl.carousel', syncPosition2);

  
  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;

    //if you disable loop you have to comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - (el.item.count / 2) - .5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    //end block

    sync2
    .find(".owl-item")
    .removeClass("current")
    .eq(current)
    .addClass("current");
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();

    if (current > end) {
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }

  sync2.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
  });*/
  
    $('.country-placeholder-top').on('click', function (e) {
     $('html,body').animate({scrollTop: '0px'}, 0);
     $('.country-dropdown').toggleClass('open');
     $('body').toggleClass('lock-scroll');
   });

  $('.country-placeholder-bottom').on('click', function (e) {
    $('html,body').animate({scrollTop: '0px'}, 0);
    $('.country-dropdown').addClass('open');
    $('body').addClass('lock-scroll');
  });

  $('.country-close').on('click', function (e) {
    $('.country-dropdown').removeClass('open');
    $('body').removeClass('lock-scroll');
  });
  
  var bindSearchFilterEvents = function() {
        $('.country-search__input').attr(
            'autocomplete',
            'off'
        ).bind(
            'keyup change search',
            function () {
                var filterRegex = new RegExp(this.value, 'i');
                $('.currency-flag').each(function (i, o) {
                    if($(o).data('regex') == 'Selected') {
                        $(o).removeClass('hide');
                    } else if (filterRegex.test($(o).data('regex'))) {
                        $(o).removeClass('hide');
                    } else {
                        $(o).addClass('hide');
                    }
                });
                $('.country-search__input').val(this.value);
            }
        );
      };

      bindSearchFilterEvents();
    $(".li-selected-country").click(function(){
      	var currency_name = $(this).data("cname");
        //console.log(currency_name);
        $(".currency_select_options option[value="+currency_name+"]").prop('selected', true); 
        $(".currency_select_options").parents("form").submit();
      });
});

